
















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class HomeCarouselFrame extends Vue {
  @Prop({ type: Boolean, default: true }) showArrows!: boolean;
  @Prop({ type: Boolean, default: false }) full!: boolean;
}
